import { isValid } from "@fnando/cpf";

export function validateCPF(cpf) {
  return isValid(cpf);
}
